<template>
  <div>
    <vueper-slides
      :dragging-distance="isSmallScreenBanner ? 70 : 70"
      prevent-y-scroll
      autoplay
      :duration="9000"
      :infinite="false"
      ref="myCarousel"
      :touchable="isSmallScreenBanner ? false : true"
    >
      <vueper-slide
        v-for="(slide, index) in slides"
        :key="index"
        :image="
          isSmallScreenBanner
            ? slide.mobileImage + version
            : slide.image + version
        "
      >
      </vueper-slide>
      <template #addons>
        <pagination class="carousel__pagination" />
        <navigation v-if="isSmallScreen" />
      </template>
    </vueper-slides>
  </div>
</template>

<script>
import avoidDoubleClick from "@/mixins/avoidDoubleClick";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import pkg from "../../../package.json";
export default {
  components: { VueperSlides, VueperSlide },
  data() {
    return {
      isResizing: false,
      isScrolling: false,
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
      version: pkg.version,
      slides: [
        {
          title: "Banner 1",
          image:
            "https://storage.googleapis.com/camasy-images/casino/theearcasino/website/banner_1.jpeg?v=",
          mobileImage:
            "https://storage.googleapis.com/camasy-images/casino/theearcasino/website/banner_1_mobile.jpeg?v=",
          infoClass: "top-left",
        },
        {
          title: "Banner 2",
          image:
            "https://storage.googleapis.com/camasy-images/casino/theearcasino/website/banner_2.jpeg?v=",
          mobileImage:
            "https://storage.googleapis.com/camasy-images/casino/theearcasino/website/banner_2_mobile.jpeg?v=",
          infoClass: "top-left",
        },
        {
          title: "Banner 3",
          image:
            "https://storage.googleapis.com/camasy-images/casino/theearcasino/website/banner_3.png?v=",
          mobileImage:
            "https://storage.googleapis.com/camasy-images/casino/theearcasino/website/banner_3_mobile.jpeg?v=",
          infoClass: "bottom-right",
        },
        {
          title: "Banner 4",
          image:
            "https://storage.googleapis.com/camasy-images/casino/theearcasino/website/banner_4.jpeg?v=",
          mobileImage:
            "https://storage.googleapis.com/camasy-images/casino/theearcasino/website/banner_4_mobile.jpeg?v=",
          infoClass: "bottom-left",
        },
      ],
      selectedSlide: 0,
      isSmallScreen: window.innerWidth >= 581,
      isSmallScreenBanner: window.innerWidth <= 580,
    };
  },
  mixins: [avoidDoubleClick],
  mounted() {
    window.addEventListener("resize", this.updateScreenSize);
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
  },
  watch: {
    // isScrolling() {
    //   this.updateTouchDrag();
    // },
  },
  methods: {
    handleScroll() {
      this.isScrolling = true;
      setTimeout(() => {
        this.isScrolling = false;
      }, 2000);
    },
    handleResize() {
      this.isResizing = true;
      setTimeout(() => {
        this.isResizing = false;
      }, 200);
    },
    updateScreenSize() {
      this.isSmallScreen = window.innerWidth >= 581;
      this.isSmallScreenBanner = window.innerWidth <= 580;
    },
  },
};
</script>

<style scoped>
@media (min-width: 992px) {
  .wrapper {
    padding: 0px 0px;
  }
}

@media screen and (max-width: 991px) and (min-width: 600px) {
  /* .wrapper {
    padding: 0px 5px;
  }// */
}

@media screen and (max-width: 599px) {
  /* .wrapper {
    padding: 0px 5px;
  } */
}
.wrapper {
  position: relative;
  width: 100%;
  max-height: 100vh;
}

.wrapper .slider-wrapper {
  max-height: 100vh;
  max-width: 100%;
  /* border-radius: 16px !important; */
}
img {
  object-fit: cover;
  width: 100%;
  /*
  min-height: calc(100vh - 80px); */
}

input {
  display: none;
}

.inner {
  width: 100%;
  line-height: 0;
  cursor: inherit !important;
  float: left;
  position: relative;
  pointer-events: none;
  user-select: none;
}

.inner:active {
  cursor: inherit !important;
}

.slider-prev-next-control .prev,
.slider-prev-next-control .next {
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fff;
  opacity: 0.7;
  cursor: pointer;
  z-index: 1;
  text-align: center;
  font-size: 24px;
  line-height: 40px;
  color: #333;
  transition: 0.3s all;
}

.slider-prev-next-control .prev {
  left: 10px;
}

.slider-prev-next-control .next {
  right: 10px;
}

.slider-prev-next-control .prev:hover,
.slider-prev-next-control .next:hover {
  opacity: 1;
  transition: 0.3s all;
}

.arrow-slider-control-svg {
  width: 35px;
  height: 35px;
  object-fit: fill;
  transition: 0.3s all;
  text-align: center;
  font-size: 24px;
  line-height: 40px;
  position: absolute;
  left: -1px;
  top: -3px;
}
.slider-dot-control {
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
}
.slider-dot-control label {
  cursor: pointer;
  border-radius: 50px;
  display: inline-block;
  width: 15px;
  height: 15px;
  background: #bbb;
  -webkit-transition: all 0.1s;
  -moz-transition: all 0.1s;
  transition: all 0.1s;
  margin: 0px 5px;
}
.slider-dot-control label:hover {
  background: #b3afaf;
}

/* Info Box */
/* .text-hover-carousel { //old
  position: absolute;
  line-height: 20px;
  opacity: 1;
  top: 15px;
  left: 50%;
  max-width: 650px;
  transform: translateX(-50%);
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
} */

.text-hover-carousel {
  position: absolute;
  line-height: 20px;
  opacity: 1;
  top: 0%;
  left: 50%;
  max-width: 650px;
  height: 70%;
  transform: translateX(-50%);
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

/* Slider Styling */
.slider-wrapper {
  width: 100%;
  overflow: hidden;
  box-shadow: 5px 1px 8px 2px #00000080;
  background: transparent;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
  transition: all 0.5s ease-out !important;
}
.slider-wrapper .inner {
  transform: translateZ(0);
  transition: all 0.8s cubic-bezier(0.77, 0, 0.175, 1);
}

.slider-wrapper .inner img {
  max-height: 100%;
}

.title-carousel-hover {
  font-size: clamp(20px, 4vw, 60px);
}

.sub-title-carousel-hover {
  font-size: clamp(8px, 4vw, 16px);
}

/*---- TABLET ----*/
@media only screen and (max-width: 850px) and (min-width: 451px) {
  .slider-wrapper {
    border-radius: 0;
  }
}
/*---- MOBILE----*/
@media only screen and (max-width: 450px) {
  .slider-wrapper {
    border-radius: 0;
  }

  .slider-wrapper .info {
    opacity: 0;
  }
}
</style>

<style>
.carousel__viewport {
  box-shadow: 5px 1px 8px 2px #00000080;
}
</style>

<style>
.Caroseul-HomePage {
  position: relative;
  width: 100%;
  height: 100vh;
  /* max-height: 90vh;
  height: calc(9 / 16 * 100vw - 0px); */
}

.carousel__pagination {
  display: flex;
  justify-content: center;
  list-style: none;
  position: relative;
  line-height: 0;
  margin: -40px 0 0;
  width: 100%;
}

.carousel__icon {
  display: block;
  width: 30px;
  height: 30px;
  -o-object-fit: contain;
  object-fit: contain;
  fill: #e6d38e !important;
  background: transparent !important;
  border-radius: 50%;
  opacity: 0.8;
}

.carousel__pagination-item li {
  margin: 0px 5px;
}

.carousel__pagination-button:hover::after,
.carousel__pagination-button--active::after {
  background-color: white;
  border: 3px solid transparent;
}

.carousel__pagination-button::after {
  display: flex;
  justify-content: center;
  text-align: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: lightgrey;
}

.carousel__pagination-button {
  display: block;
  border: 0;
  margin: 0;
  cursor: pointer;
  background: transparent;
}

.carousel__pagination-button--active {
  display: flex;
  justify-content: center;
  text-align: center;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  text-align: center;
  position: relative;
  background: cornflowerblue;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border-image: cornflowerblue;
}

.carousel__pagination-button:hover::after,
.carousel__pagination-button--active::after {
  background-color: white !important;
}

.carousel__prev,
.carousel__next {
  width: 40px;
}

.carousel__icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  fill: black;
  background: white;
  border-radius: 50%;
  opacity: 0.8;
}

#carouselBanner .carousel__viewport {
  border-radius: 0px !important;
}

ol.carousel__track {
  margin-bottom: 0px !important;
}
</style>

<style>
.vueperslides {
  position: relative;
  max-width: 100%;
  margin: 0 auto;
}

.vueperslides__parallax-wrapper {
  max-height: 100vh;
  max-width: 100%;
}

@media (max-width: 768px) {
  .vueperslides__parallax-wrapper {
  }
}

.vueperslides__track {
  position: absolute;
  height: 100%;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 1;
  bottom: 0;
}

.vueperslide {
  white-space: normal;
  background-size: cover;
  flex-shrink: 0;
  display: block;
  width: 100%;
  position: relative;
  height: auto;
}

@media (max-width: 580px) {
  .vueperslides__parallax-wrapper {
    padding-bottom: 155% !important;
    /* height: 90vh; */
  }
}

@media (min-width: 581px) {
  .vueperslides__parallax-wrapper {
    padding-bottom: 48% !important;
  }
}

.vueperslide,
.vueperslide__image {
  /* background-position: top center !important; */
}

.vueperslides__track-inner {
  white-space: nowrap;
  transition: 0.9s ease-in-out transform;
  height: 100%;
  display: flex;
}
.vueperslides__arrow svg {
  vertical-align: middle;
  stroke: currentColor;
  fill: none;
  width: 2rem;
  height: 2rem;
  padding: 10px;
  stroke-width: 4px !important;
  transition: 0.3s ease-in-out;
  box-sizing: border-box;
  background: #0081ff78;
  border-radius: 50%;
}

.vueperslides__arrow svg:hover {
  stroke-width: 4px !important;
  background: #0080ff;
}

.vueperslides__bullets {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 10px;
  left: 50%;
  right: 0;
  z-index: 2;
  width: fit-content;
  transform: translate(-50%, 0.5%);
  border-radius: 90px;
  backdrop-filter: blur(250px);
  background: #ffffff57;
  box-shadow: 0px 0px 25px -4px #2b29294f;
}

.vueperslides__bullet {
  margin: 10px;
  padding: 0;
  border: none;
  background: none;
}

.test::before {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 2;
  background-color: red;
  width: 100%;
  height: 100%;
  pointer-events: none !important;
  touch-action: none !important;
}
</style>
